import { AuthError } from "firebase/auth";
import ReactGA from 'react-ga4';

const errorCodeToMessage: Map<string, string> = new Map<string, string>([
    ['auth/popup-closed-by-user', "The sign-in popup was closed by the user."],
    ['auth/cancelled-popup-request', "The sign-in request was cancelled."],
    ['auth/network-request-failed', "A network error occurred. Please check your internet connection and try again."],
    ['auth/unauthorized-domain', "This domain is not authorized for authentication. Please contact support."],
    ['auth/popup-blocked', "The sign-in popup was blocked by your browser. Please allow popups for this site."]
]);

export const handleAuthErrors = (error: unknown, action: string): string | undefined => {
    const authError = error as AuthError;
    if (!authError) {
        return undefined;
    }

    ReactGA.event({
        category: 'Error',
        action: action,
        label: authError.message,
        nonInteraction: true, // Indicates this event doesn't affect bounce rate
        value: 1, // Optional: You could increment this for each error
    });

    const errorMessage = errorCodeToMessage.has(authError.code)
        ? errorCodeToMessage.get(authError.code)
        : "An unexpected error occurred during Google sign-in.";
    console.error("Unhandled Firebase Auth error:", errorMessage);

    return errorMessage;
}
